<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <h1 class="title">Quick payments</h1>
      <app-cells>
        <app-input
          @input.native="onItemSearch"
          v-model="search"
          class="input--300"
          type="search"
          placeholder="Search by invoice, name, phone"
          name="search"
        />
        <app-filters
          v-model="method_filter"
          :filters="method_filter_options"
          name="method"
          @change="onChangeFilter"
        />
        <app-filters
          v-model="status_filter"
          :filters="status_filter_options"
          name="status"
          @change="onChangeFilter"
        />
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #h__status><div class="table-default__left">Status</div></template>
        <template #created_at="{ row }">{{ dateTimeFormat(row.created_at) }}</template>
        <template #invoice_number="{ row }">{{ row.invoice_number || '-' }}</template>
        <template #name="{ row }"><div class="table-default__left">{{ row.name }}</div></template>
        <template #amount_gross="{ row }">{{ Intl.NumberFormat('ru-RU').format(row.amount_gross) }} {{ row.currency.code }}</template>
        <template #amount_commission="{ row }">{{ Intl.NumberFormat('ru-RU').format(row.amount_commission) }} {{ row.currency.code }}</template>
        <template #amount_received="{ row }">{{ Intl.NumberFormat('ru-RU').format(row.amount_received) }} {{ row.currency.code }}</template>
        <template #payment_method="{ row }">{{ capitalizeString(row.payment_method) }}</template>
        <template #status="{ row }">
          <div class="table-default__left">
            <span
              class="status-tag"
              :style="{ 'backgroundColor': row.paid ? '#77b017' : '#e85c20' }"
            >
              {{ row.paid ? 'Paid' : 'Unpaid' }}
            </span>
          </div>
        </template>
        <template #payment="{ row }">{{ row.paid ? dateTimeFormat(row.created_at) : '-' }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getFinanceQuickPaymentsList } from '@/http'
import debounce from 'lodash/debounce'
import capitalize from 'lodash/capitalize'
import { format, parseISO } from 'date-fns'

export default {
  name: 'FinanceQuickPayments',
  data() {
    return {
      is_loaded: false,
      search: '',
      table_preloader: false,
      method_filter: '',
      status_filter: 'true',
      method_filter_options: [
        { value: '', label: 'All' },
        { value: 'stripe', label: 'Stripe' },
        { value: 'kassa', label: 'Kassa' },
      ],
      status_filter_options: [
        { value: 'true', label: 'Paid' },
        { value: 'false', label: 'Unpaid' },
        { value: '', label: 'All' },
      ],
      table: {
        items: [],
        columns: ['created_at', 'invoice_number', 'name', 'amount_gross', 'amount_commission', 'amount_received', 'payment_method', 'status', 'payment'],
        options: {
          headings: {
            created_at: 'Created',
            invoice_number: 'Invoice',
            name: 'Name',
            amount_gross: 'Deducted',
            amount_commission: 'Commission',
            amount_received: 'Received',
            payment_method: 'Method',
            status: 'Status',
            payment: 'Payment',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      getFinanceQuickPaymentsList({
        page: this.pagination.page,
        page_size: 20,
        search: this.search,
        payment_method: this.search ? '' : this.method_filter,
        paid: this.search ? '' : this.status_filter === '' ? '' : this.status_filter === 'true'
      })
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.is_loaded = true
          this.table_preloader = false
        })
    },
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    onChangeFilter() {
      this.search = ''
      this.pagination.page = 1
      this.fetchItems()
    },
    capitalizeString(str) {
      return capitalize(str)
    },
    onItemSearch() {
      this.searchItem(this)
    },
    searchItem: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
  }
}
</script>
